import { useEffect, useState } from "react";
import { PessoaDto, PessoaFiltrarDto, PessoaFiltrarSchema } from "./Pessoa.Dto";
import { PessoaFiltrar } from "src/services/Entidade.Service";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MapearErrosServidor } from "src/hook/Functions";
import { IRoute } from "src/interfaces/IRoute";
import { showToast } from "src/componentes";

const PessoaCode = () => {
  const [pessoaData, setPessoaData] = useState<PessoaDto[] | undefined>([]);
  const [loading, setLoading] = useState(false);
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    getValues,
  } = useForm<PessoaFiltrarDto>({
    resolver: yupResolver(PessoaFiltrarSchema),
    defaultValues: { nome: "", perfilPessoa: 1 },
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setMenuItens([
        { name: "Nova Pessoa...", route: "/entidade/pessoa/cadastro" },
      ]);
      handleSubmit(onSubmit)();
    };

    Load();
    return () => {
      controller.abort();
    };
  }, []);

  const onSubmit = async (data: PessoaFiltrarDto) => {
    setLoading(true);
    try {
      const response = await PessoaFiltrar(data);
      if (response.data.success) {
        const data = response.data.data;
        setPessoaData(data);
        if (data.length == 0) {
          showToast({
            message: "Não encontrado",
            title: "Info",
            variant: "Info",
          });
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      setPessoaData(undefined);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const radios = [
    { name: "Cliente", value: "1" },
    { name: "Fornecedor", value: "2" },
    { name: "Ambos", value: "3" },
  ];

  return {
    pessoaData,
    loading,
    register,
    errors,
    handleSubmit,
    onSubmit,
    radios,
    setValue,
    getValues,
    menuItens,
    setMenuItens,
  };
};
export default PessoaCode;
